<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home-page']"
    titlePrefix="Velocifyx - Smart Advertising, Measurable Results"
    metaDescription="Connect with the right audience through our seamless, transparent ad trading platform. Access premium inventory, optimize campaigns in real time, and leverage expert support to drive measurable growth for your brand.">

    <section class="hero-section">
      <div class="hero-section__content">
        <h1 class="hero-section__title">Smart Advertising, Measurable Impact</h1>
        <p class="hero-section__subtitle">
          From precise audience targeting to data-driven Premium Inventory Access, we deliver tailored advertising solutions that amplify your brand reach and drive real results across multiple platforms.
        </p>
        <a href="/#footer-section" class="hero-section__cta-button">
          <span>Contact Us</span>
          <img src="@/assets/banner-contact-arrow.svg" alt="arrow">
        </a>
      </div>
    </section>

    <section class="data-section">
      <div class="data-section__item" v-for="(item, index) in dataItems" :key="index">
        <div class="data-section__value">{{ item.value }}</div>
        <div class="data-section__label">{{ item.label }}</div>
      </div>
    </section>

    <section class="services-section">
      <div class="services-section__header">
        <h2 class="services-section__title">Services We Provide</h2>
        <p class="services-section__subtitle">
          We offer high-quality advertising solutions designed to help brands expand reach, optimize campaigns, and maximize return on investment.
        </p>
      </div>
      <div class="services-section__grid">
        <div class="service-card" v-for="(service, index) in services" :key="index">
          <img :src="service.image" :alt="service.title" class="service-card__image">
          <div class="service-card__content">
            <h3 class="service-card__title">{{ service.title }}</h3>
            <p class="service-card__description">{{ service.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="why-section">
      <div class="why-section__header">
        <h2 class="why-section__title">Why choose us？</h2>
        <p class="why-section__subtitle">
          Proven technology, dedicated expertise, and clear processes to drive your advertising growth.
        </p>
      </div>
      <div class="why-section__content">
        <div class="why-section__image-container">
          <img src="@/assets/why.png" alt="Why choose us placeholder" class="why-section__image">
        </div>
        <div class="why-section__features">
          <div class="feature-item" v-for="(feature, index) in features" :key="index">
            <div class="feature-item__number">{{ index + 1 }}</div>
            <div class="feature-item__text">
              <h3 class="feature-item__title">{{ feature.title }}</h3>
              <p class="feature-item__description">{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section">
      <p class="trust-section__text">Trusted by Industry Leaders Worldwide</p>
    </section>

    <section class="partners-section">
      <div class="partners-section__header">
        <h2 class="partners-section__title">Partners</h2>
      </div>
      <div class="partners-section__grid">
        <div class="partner-logo" v-for="(partner, index) in partners" :key="index">
          <img :src="partner.image" :alt="partner.name">
        </div>
      </div>
    </section>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
  },
  mixins: [common],
  data () {
    return {
      dataItems: [
        { value: '500M+', label: 'Ads delivered across premium global platforms monthly.' },
        { value: '98%', label: 'Average campaign success rate driving measurable ROI.' },
        { value: '24/7', label: 'Continuous optimization and monitoring for peak performance.' }
      ],
      services: [
        {
          title: 'Targeted Audience Reach',
          description: 'Precisely connect your brand with the right audience across multiple platforms.',
          image: require('@/assets/service-1.png')
        },
        {
          title: 'Real-Time Premium Inventory Access',
          description: ' Continuously monitor and adjust campaigns to maximize performance and ROI.',
          image: require('@/assets/service-2.png')
        },
        {
          title: 'Premium Inventory Access',
          description: 'Gain exclusive access to high-quality ad spaces that drive impactful results.',
          image: require('@/assets/service-3.png')
        },
        {
          title: 'Data-Driven Insights',
          description: 'Leverage actionable analytics to inform strategies and improve campaign outcomes.',
          image: require('@/assets/service-4.png')
        }
      ],
      features: [
        {
          title: 'Global Ad Network Integration',
          description: 'Connect effortlessly with top advertising platforms, ensuring your campaigns reach the right audience everywhere.'
        },
        {
          title: 'Dedicated Account Management',
          description: 'Our skilled team provides personalized support and rapid solutions to keep your campaigns performing at their best.'
        },
        {
          title: 'Clear Performance & Reporting',
          description: 'With transparent analytics and real-time insights, we help you optimize spend and maximize ROI.'
        }
      ],
      partners: [
        { name: 'Amazon', image: require('@/assets/Amazon.png') },
        { name: 'Yandex', image: require('@/assets/Yandex.png') },
        { name: 'Zalora', image: require('@/assets/Zalora.png') },
        { name: 'Google', image: require('@/assets/Google.png') },
        { name: 'Tinder', image: require('@/assets/Tinder.png') },
        { name: 'Meta', image: require('@/assets/Meta.png') },
        { name: 'Telecoming', image: require('@/assets/Telecoming.png') },
        { name: 'TikTok', image: require('@/assets/TikTok.png') }
      ]
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted () {
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  methods: {
    scrollToSection (hash) {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },

  }
};
</script>

